<template>
  <div>
    <v-radio-group
      v-if="showPureRadio"
      v-model="selectedOptionIndex"
      :error-messages="errorMessages"
      hide-details="auto"
      density="compact"
      @update:model-value="confirm()"
    >
      <v-radio
        v-for="(opt, index) in options"
        :key="opt.id"
        :label="opt.value"
        :value="index"
        class="!not-last:wd-mb-5"
        color="orange50"
        @click="onUnchecked(index)"
      >
        <template #label>
          <span class="wd-text-md wd-font-normal wd-text-black50">{{ opt.value }}</span>
        </template>
      </v-radio>
    </v-radio-group>
    <template v-else>
      <!-- remark-radio-picker -->
      <v-text-field
        v-model="fieldValue"
        class="mb-4 wd-h-10"
        bg-color="white"
        color="orange50"
        density="compact"
        readonly
        variant="outlined"
        single-line
        :placeholder="placeholder"
        :error-messages="errorMessages"
        @click.stop="open()"
      >
        <template #append-inner>
          <div>
            <funnow-icon class="mt-1" max-width="20" image-path="chevron-down.svg" />
          </div>
        </template>
      </v-text-field>
    </template>
    <modal-pure-hint v-model="isOpen" :title="title" show-button @confirm="confirm" @close="close">
      <div>
        <v-radio-group v-model="selectedOptionIndex" density="compact" hide-details>
          <div v-for="(opt, index) in options" ref="radioRef" :key="opt.id" class="not-first:wd-pt-5">
            <v-radio :label="opt.value" :value="index" color="orange50" class="wd-px-3 !wd-mb-5" @click="onUnchecked(index)">
              <template #label>
                <span class="wd-text-md wd-font-normal wd-text-black50">{{ opt.value }}</span>
              </template>
            </v-radio>
            <v-divider />
          </div>
        </v-radio-group>
      </div>
    </modal-pure-hint>
  </div>
</template>

<script>
import { useVModel } from '@vueuse/core'
import ModalPureHint from '@/components/ModalPureHint.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import { sleep } from '~/utils/utils'

export default defineComponent({
  components: {
    ModalPureHint,
    FunnowIcon,
  },
  props: {
    title: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    modelValue: { type: String, default: '' },
    optionIndex: { type: Number, default: -1 },
    errorMessages: { type: Array, default: () => [] },
    required: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'update:optionIndex', 'close'],
  setup(props, ctx) {
    const fieldValue = useVModel(props, 'modelValue', ctx.emit)
    const showPureRadio = computed(() => props.options.length <= 3)
    const isOpen = ref(false)
    const selectedOptionIndex = ref(props.optionIndex)
    const selectedOption = computed(() => props.options[selectedOptionIndex.value])
    const previousOptionIndex = ref(-1)
    const radioRef = useTemplateRef('radioRef')

    function onUnchecked(index) {
      selectedOptionIndex.value = index
      if (index === previousOptionIndex.value && !props.required) {
        selectedOptionIndex.value = -1
      }
      previousOptionIndex.value = selectedOptionIndex.value
      if (showPureRadio.value) {
        confirm()
      }
    }

    async function open() {
      isOpen.value = true
      selectedOptionIndex.value = props.optionIndex
      await nextTick()
      await sleep(200)
      scrollToRadioItem()
    }

    function confirm() {
      fieldValue.value = selectedOption.value?.value || ''
      ctx.emit('update:optionIndex', selectedOptionIndex.value)
    }

    async function close() {
      await nextTick()
      ctx.emit('close')
    }

    function scrollToRadioItem() {
      if (props.options.length <= 3) {
        return
      }
      /** @type {HTMLElement} */
      const targetRadioItemDOM = radioRef.value[selectedOptionIndex.value]
      if (!targetRadioItemDOM) {
        return
      }
      targetRadioItemDOM.scrollIntoView({ block: 'center', behavior: 'auto' })
    }

    return {
      fieldValue,
      showPureRadio,
      isOpen,
      selectedOptionIndex,
      open,
      confirm,
      close,
      onUnchecked,
      previousOptionIndex,
    }
  },
})
</script>
